import React, { FC } from 'react';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import { NoSSR } from '~/src/helpers/noSSR.helper';
import BgImg from '~/src/images/agency-products/bg.png';
import BookImg from '~/src/images/agency-products/book.png';
import * as Styled from './agency-products-banner.styles';

export const AgencyProductsBanner: FC = () => {
    const [isTabletWide] = useMatchMedia(MediaWidthEnum.tabletWide, { withoutSSR: true });

    return (
        <Styled.AboutProductBannerContainer>
            <Styled.AgencyProductsBannerContent>
                <Styled.AboutProductBannerTitle>Агентские продукты</Styled.AboutProductBannerTitle>
                <Styled.BottomContainer>
                    <Styled.SubText>
                        База знаний о продуктах, которые выгодно рекомендовать своим клиентам. Здесь вы можете найти
                        много полезной информации: описание продуктов, вебинары, презентации и другие материалы, которые
                        помогут увеличить продажи
                    </Styled.SubText>
                </Styled.BottomContainer>
            </Styled.AgencyProductsBannerContent>
            <NoSSR>
                <>
                    <Styled.BannerBookImage
                        width={isTabletWide ? 250 : 339}
                        height={isTabletWide ? 200 : 295}
                        alt={'Логотип продукта МТС'}
                        src={BookImg || ''}
                        priority={true}
                        quality={IMAGE_QUALITY.HIGH}
                    />
                    {!isTabletWide && (
                        <Styled.BannerBgImage
                            width={293}
                            height={360}
                            alt={'Логотип продукта МТС'}
                            src={BgImg || ''}
                            priority={true}
                            quality={IMAGE_QUALITY.HIGH}
                        />
                    )}

                </>
            </NoSSR>
        </Styled.AboutProductBannerContainer>
    );
};
